export const getRecaptchaScript = () => `<script id="recaptcha-script">
document.addEventListener('DOMContentLoaded', function() {
    const recaptchaContainer = document.querySelector('.template-editor__recaptcha-wrapper');
    if (recaptchaContainer) {
        const s = document.createElement("script");
        s.defer = true;
        s.async = true;
        s.src = "https://www.google.com/recaptcha/api.js";
        document.body.appendChild(s);
    }
    const forms = document.querySelectorAll('form');
    forms.forEach((form, index) => {
        const formRecaptchaContainer = form.querySelector('.template-editor__recaptcha-wrapper');
        if (!formRecaptchaContainer) {
            return;
        }
        const recaptchaCallbackName = \`recaptchaCallback\${index}\`;
        const recaptchaExpiredCallbackName = \`recaptchaExpiredCallback\${index}\`;

        window[recaptchaCallbackName]  = () => {
            form.querySelector('input[type="submit"]')?.removeAttribute("disabled");
        };
        window[recaptchaExpiredCallbackName] = () => {
            form.querySelector('input[type="submit"]')?.setAttribute("disabled", "");
        };
        formRecaptchaContainer.innerHTML = \`<div class="g-recaptcha" data-sitekey="6LcrnnAeAAAAAKCHYWuH2_5kSi9xvFn298xVJsZQ" data-callback="\${recaptchaCallbackName}" data-expired-callback="\${recaptchaExpiredCallbackName}"></div>\`;
        form.querySelector('input[type="submit"]')?.setAttribute("disabled", "");
    });
});
</script>`;
